"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const reactstrap_1 = require("reactstrap");
const graphql_1 = require("../../../graphql");
const BaseAuthModal_1 = require("./BaseAuthModal");
const hooks_1 = require("../../../hooks");
const react_2 = require("@osmosys/react");
// interface IState {}
exports.LoginModal = props => {
    const { appSettings } = hooks_1.useOsmosysContext();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(BaseAuthModal_1.BaseAuthModal, Object.assign({ osysSubType: "login", isOpen: props.isOpen, title: "Login to Osmosys", fields: ['email', 'password'], mutation: graphql_1.login, buttonText: "Login", getVars: ({ password, email }) => {
                return {
                    data: {
                        email,
                        password,
                    },
                };
            }, successText: "Welcome", linkComp: appSettings &&
                appSettings.allowSignups && (react_1.default.createElement("p", { className: "text-muted" },
                "or ",
                react_1.default.createElement(react_router_dom_1.Link, { to: "/signup" }, "create new account"),
                ".")), extraButton: react_1.default.createElement(reactstrap_1.Button, { color: "light", tag: react_router_dom_1.Link, to: "/forgot-password" }, "Forgot password"), showMagicLink: true }, props)),
        react_1.default.createElement(react_2.OsmosysToast, { title: "Osmosys 5.0", uncontrolledDismissal: true },
            react_1.default.createElement("p", null, "You're now using the latest version of Osmosys!"),
            react_1.default.createElement("p", null, "If you encounter any problems, you may access the previous version here:"),
            react_1.default.createElement("div", null,
                react_1.default.createElement(react_2.OsmosysButton, { size: "sm", osysName: "retired.osmosys.app", color: "dark", className: "w-100", osysIcon: "externalLink", iconPosition: "right", href: "https://retired.osmosys.app", full: true }, "https://retired.osmosys.app")))));
};
exports.default = exports.LoginModal;
//# sourceMappingURL=LoginModal.js.map